import { LCBatchesPresentationOrderEnum } from '../../compat/tvpil';
import type { Channel } from '../types';

import { compareByChannelNumber, compareByFavorite, compareByWatchCount } from './sortComparators';

type SortChannelsOptions = {
  favoriteChannels: Map<number, number>;
  mostWatchedChannels: Map<number, number>;
  orderBatches: LCBatchesPresentationOrderEnum[];
};

export type ComparatorOptions = {
  favoriteChannels: Map<number, number>;
  mostWatchedChannels: Map<number, number>;
};

export type Comparator = (a: Channel, b: Channel, options: ComparatorOptions) => number;

const comparators: Record<LCBatchesPresentationOrderEnum, Comparator> = {
  [LCBatchesPresentationOrderEnum.lcn]: compareByChannelNumber,
  [LCBatchesPresentationOrderEnum.fav]: compareByFavorite,
  [LCBatchesPresentationOrderEnum.top_x]: compareByWatchCount,
};

export function sortChannels(
  channels: Array<Channel>,
  { favoriteChannels, mostWatchedChannels, orderBatches }: SortChannelsOptions,
): Array<Channel> {
  const sorted = channels.sort((a, b) => {
    for (const batch of orderBatches) {
      const compareFn = comparators[batch];

      if (!compareFn) {
        return 0;
      }

      const compareResult = compareFn(a, b, { favoriteChannels, mostWatchedChannels });

      if (compareResult !== 0) {
        return compareResult;
      }
    }

    return 0;
  });

  return sorted;
}
